// よくある質問

// 目次
//---h2がないときは表示しない----- 
$(function () {
	if (!($('.toc-target-area h2').length)) {
		$('#toc').addClass('d-none');
	}
});

if ($('#toc').length > 0) {
	$(function () {
		$("#toc")
			.append('<p class="index-title">目次 [<a href="javascript:void(0);" class="toggle-index">隠す</a>]</p><ul class="index"></ul>');
		// .toc-target内にある見出し（h2, h3, h4）を、目次に入れます
		$(".toc-target-area h2, .toc-target-area h3, .toc-target-area h4").each(function (i) {
			var current = $(this);
			current.attr("id", "title" + i);
			if (current.get(0).tagName == 'H2') {
				$("#toc ul").append('<li class="level1"><a id="link' + i + '" href="#title' + i + '">' + current.text() + "</a></li>");
			}
			if (current.get(0).tagName == 'H3') {
				$("#toc ul").append('<li class="level2"><a id="link' + i + '" href="#title' + i + '">' + current.text() + "</a></li>");
			}
			if (current.get(0).tagName == 'H4') {
				$("#toc ul").append('<li class="level3"><a id="link' + i + '" href="#title' + i + '">' + current.text() + "</a></li>");
			}
		});
		// h2(level1)だけ数字を振る
		var i = 1;
		$('.column-page  .level1').each(function () {
			$(this).prepend('<span class="num">' + i + '.' + '</span>');
				i++;
			});
		var i = 1;
});
	
}

// 目次隠す
$(function () {
	$('.toggle-index').on('click', function () {
		$('.index').toggleClass('close');
	});
});

// スムーススクロール
$(function () {
	$('.level1 a[href*="#"],.level2 a[href*="#"],.level3 a[href*="#"]').click(function () {
		var elmHash = $(this).attr('href'); 
		var pos = $(elmHash).offset().top - 110;//idの上部の距離からHeaderの高さを引いた値を取得
		if (window.matchMedia('(max-width: 768px)').matches) {
			var pos = $(elmHash).offset().top;
		};
		$('body,html').animate({ scrollTop: pos }, 500); 
		return false;
	});
});



